import { Grid, Typography } from "@mui/material";
import Image from "next/image";
import officeImg1 from "../../public/assets/images/home/more/career/officeImg1.webp";
import officeImg2 from "../../public/assets/images/home/more/career/officeImg2.webp";
import officeImg3 from "../../public/assets/images/home/more/career/officeImg3.webp";
import officeImg4 from "../../public/assets/images/home/more/career/officeImg4.webp";
import officeImg5 from "../../public/assets/images/home/more/career/officeImg5.webp";
import officeImg6 from "../../public/assets/images/home/more/career/officeImg6.webp";
import floatingIcon1 from "../../public/assets/images/home/more/career/floatingIcon1.webp";
import floatingIcon2 from "../../public/assets/images/home/more/career/floatingIcon2.webp";
import floatingIcon3 from "../../public/assets/images/home/more/career/floatingIcon3.webp";

const images = [
  { src: officeImg5, alt: "officeImg5" },
  { src: officeImg6, alt: "officeImg6" },
  { src: officeImg3, alt: "officeImg3" },
  { src: officeImg4, alt: "officeImg4" },
  { src: officeImg2, alt: "officeImg2" },
  { src: officeImg1, alt: "officeImg1" },
];

const floatingIcons = [
  {
    src: floatingIcon1,
    alt: "floatingIcon1",
    style: { top: "18%", right: "15%" },
  },
  {
    src: floatingIcon2,
    alt: "floatingIcon2",
    style: { left: "10%", right: "20%", bottom: "10%" },
  },
  {
    src: floatingIcon3,
    alt: "floatingIcon3",
    style: { top: "4%", right: "11%" },
  },
];

function GromoGallery() {
  return (
    <Grid sx={{ padding: "4%", display: "grid", margin: "auto" }}>
      <Typography
        sx={{
          color: "#0A0C0F",
          fontSize: { xs: "20px", md: "32px" },
          lineHeight: { md: "40px" },
          fontWeight: 500,
          textAlign: "center",
          margin: { md: "12px 0 48px 0" },
        }}
      >
        Collaborate with the best of{" "}
        <span style={{ fontWeight: 700, fontSize: "40px" }}>brains</span> and{" "}
        <span style={{ fontWeight: 700, fontSize: "40px" }}>hearts.</span>
      </Typography>

      <Grid
        sx={{
          display: "grid",
          gridTemplateColumns: "3fr 6fr 3fr",
          width: "80%",
          margin: "30px auto",
          position: "relative",
        }}
      >
        {images.map((img, idx) => (
          <Grid
            key={idx}
            sx={{ padding: "2%", display: "grid", placeContent: "center" }}
          >
            <Image
              src={img.src}
              alt={img.alt}
              style={{ objectFit: "contain", borderRadius: "12px" }}
              loading="lazy"
            />
          </Grid>
        ))}

        {floatingIcons.map((icon, idx) => (
          <Image
            key={idx}
            src={icon.src}
            alt={icon.alt}
            style={{
              position: "absolute",
              height: "70px",
              objectFit: "contain",
              ...icon.style,
            }}
            loading="lazy"
          />
        ))}
      </Grid>
    </Grid>
  );
}

export default GromoGallery;
